export default __webpack_public_path__ + "static/media/site planning.e8ec5611.svg";